import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router';

const CustomNavLink = forwardRef((props, ref) => (
  <div
    ref={ref}
  >
    <RouterLink {...props} />
  </div>
));

export default CustomNavLink;
